import * as React from "react";
import { useEffect, useRef, useState } from "react";
import store from "../../../storeWire";
import { system_notification } from "../../../store/slice/system";
import Cart from "@system/config/cart";
import ClearCart from "./ClearCart";
import closeIc from "src/assets/images/close-ic.png";
import ClearSingleCartProductFromCart from "./ClearSingleCartProductFromCart";
import DOMAttachToSystem from "../../../captain/DOMAttachToSystem";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import $ from "jquery";
import liveAuth from "src/helper/liveAuth";
import useCheckAuthPermissions from "src/hooks/component/useCheckAuthPermissions";
import System from "src/helper/system";
import { Tooltip } from "src/component/Tooltip";
import RoleAndPermission from "src/helper/RoleAndPermission";
import Product from "@system/config/product";
import Helper from "src/support/Helper";
import useDebounce from "../../../hooks/useDebounce";
import { isArray, isObject } from "underscore";
import noImage from "src/assets/images/noimage.png";
import AxiosIndicatorRunTimeLoader from "src/component/AxiosIndicatorRunTimeLoader";
import { useCartStore } from "src/hooks/cart";
import { isNumber } from 'underscore';
// import CartRepository from "src/repository/CartRepository";
import { __set, __remove } from "src/store/axios_indicator";
import AuthConfig from "@system/config/auth";
import NavigateToPDP from "../Product/NavigateToPDP";

const HeaderTotalCartItems = () => {
  const [__check] = useAxiosIndicatorCheck();
  const [_check_p] = useCheckAuthPermissions();
  const cartDropDown = useRef(null);
  const [CART_DATA_d, Set_CART_DATA_d] = useDebounce([], 100);
  const [{ CART_DATA, CART_PRODUCT_DATA, CART_DATA_OBJECT, CART_COUNT }, { get_cart_list_subtotal, initiatedKernelSyncCurrencyCall, fetch_cart_count, fetch_cart_data }, { }] = useCartStore();
  const [CART_DATA_OBJECT_d, Set_CART_DATA_OBJECT_d] = useDebounce({}, 100);
  const [subTotal, setSubTotal] = useState(0)
  // const [opendropdownLoader, setOpendropdownLoader] = useState(true);
  const [currencyChanged, setCurrencyChanged] = useState(false);
  const isFromCart = Helper.isCallFromCart();

  useEffect(() => {
    currencyDifferenceDetected();
  }, [CART_DATA && Object.keys(CART_DATA).length > 0]);


  useEffect(() => {
    const update = async () => {
      if (currencyChanged) {
        await initiatedKernelSyncCurrencyCall()
      }
    };
    update();
  }, [currencyChanged]);

  /**
      * author : tusharKc
   * ticket: 9125
   * changes: added function to detect currency diff. and call update api.
   */

  const currencyDifferenceDetected = () => {
    if (CART_DATA && isArray(CART_DATA) && CART_DATA.length > 0 && CART_DATA[0] !== undefined && CART_DATA[0].currency
      && window.mct && CART_DATA[0].currency !== window.mct && !isFromCart) {
      setCurrencyChanged(true);
    } else setCurrencyChanged(false);
  };

  useEffect(() => {
    async function fetchHere() {
      await fetchFromServer();
      $(document).on("click", ".dropdown-menu", function (e) {
        e.stopPropagation();
      });
    }
    if (isFromCart === false)
      fetchHere();
  }, []);


  /**
    * Author: Trilok Sain
    * Date: 17/02/2023
    * Reason: prevent pop-up from closing when click inside the cart popup
    */
  useEffect(() => {
    const preventCloseHandle = (e) => {
      const cartmodal = document.getElementById("cart-popup");
      if (cartmodal?.contains(e.target)) {
        cartDropDown.current.className = "dropdown cartCountWidget open"
      }
    }
    document.addEventListener("click", preventCloseHandle);
    return () => {
      document.removeEventListener("click", preventCloseHandle);
    }
  }, [])

  useEffect(() => {
    // Close Account Dropdown if Exist
    let accountDropdown = document?.getElementById("av-account-trigger");
    const hideCart = () => {
      let cartElem = document?.getElementById("dvCartCountWidget");
      if (cartElem !== undefined && cartElem !== null && cartElem?.classList?.contains("open")) {
        cartElem?.removeAttribute("class");
        cartElem?.setAttribute("class", "dropdown cartCountWidget");
      }
    };
    accountDropdown?.addEventListener("click", hideCart);
    return () => {
      accountDropdown?.removeEventListener("click", hideCart);
    };
  }, []);



  useEffect(() => {
    async function fetchHere() {
      if (isArray(CART_DATA) && CART_DATA.length >= 0) {
        if (Object.entries(CART_DATA_OBJECT_d)?.length === 0) {
          Set_CART_DATA_d(CART_DATA);
        } else {
          Set_CART_DATA_d([...CART_DATA].reverse());
        }
      }
      setSubTotal(get_cart_list_subtotal(CART_DATA))
    }
    fetchHere()
  }, [CART_DATA]);

  useEffect(() => {
    async function fetchHere() {
      if (isObject(CART_DATA) && Object.entries(CART_DATA_OBJECT).length >= 0) {
        Set_CART_DATA_OBJECT_d(CART_DATA_OBJECT)
      }
    }
    fetchHere()
  }, [CART_DATA_OBJECT]);

  const authLoggedIn = (keyIndex) => {
    return liveAuth.check();
  };

  const fetchFromServer = async () => {
    const isCallFromQuoteCart = Helper.isCallFromQuoteCart(); // DT - 11177 - Execute for normal Cart
    if (!isCallFromQuoteCart) {
      const CART_COUNT_ss = "CART_COUNT_" + AuthConfig.getAccountNumber() + "_" + System.auth('salesOrg') + "_" + AuthConfig.getAuthSBoat()

      if (sessionStorage.getItem(CART_COUNT_ss)) { }
      else {
        __set('CART_API_CALL_ON_PAGE_LOADING');
        __set('MINI_CART_API_CALL');
        //await new CartRepository().fetchCartCount();
        fetch_cart_count()
        __remove('CART_API_CALL_ON_PAGE_LOADING');
        __remove('MINI_CART_API_CALL');
      }
    }
  };

  const fetchDataFromServer = async () => {
    /**
     * call every time when click on mini cart
     * Author: Devanshi Patel
     * DT- 14Feb -optimize view call
     * PN- 24 April - removed cart_product_data condition for unavailable part 
     */
    // || Object.entries(CART_PRODUCT_DATA)?.length === 0
    if (Object.entries(CART_DATA)?.length === 0 || Object.entries(CART_DATA_OBJECT_d)?.length === 0) {
      __set('MINI_CART_API_CALL');
      await fetch_cart_data({ minicart: true });
      // await new CartRepository().fetchCartData(false, { minicart: true });
      __remove('MINI_CART_API_CALL');
    }
  };

  const preventCloseOnClick = () => {
    cartDropDown.current.className = "dropdown open";
    setTimeout(() => {
      cartDropDown.current.className = "dropdown open";
    }, 0.1);
  };

  const openContactUsPopup = () => {
    store.dispatch(
      system_notification({
        name: "ContactUsPopup",
        data: { restrict: true },
      })
    );
  };

  const openCart = async (e) => {
    await fetchDataFromServer();
    document.querySelectorAll("li")
      .forEach((item) => item.classList.remove("open"));

    if (authLoggedIn() === false) {
      window.location.href = System.getLoginPageUrl();
      return false;
    }

    if (_check_p("PD_VIEW_CART").status === false) {
      openContactUsPopup();
      preventCloseOnClick();
      e.preventDefault();
      return false;
    }
    // Close Account Dropdown if Exist
    let accountDropdown = document.getElementById("listing");
    if (accountDropdown !== undefined && accountDropdown !== null && accountDropdown.classList.contains("open")
    ) {
      accountDropdown.removeAttribute("class");
    }
  };

  // useEffect(() => {
  //   if (
  //     CART_DATA_d.length === CART_COUNT &&
  //     !__check(["MINI_CART_API_CALL", "CART_OPERATION_API_CALL"]).status
  //   ) {
  //     setOpendropdownLoader(false);
  //   }
  // }, [CART_DATA_d]);

  const getGuestDisplayTooltipButton = () => {
    return authLoggedIn() === false ? (
      <button
        type="button"
        className="bs5 btn btn-secondary rounded-1 dropdown-toggle ms-2 header-cart-toggle"
        onClick={(e) => (window.location.href = System.getLoginPageUrl())}
      >
        <span className="ms-1 header-cart-count d-md-inline-block text-black">
          <b>0</b>
          <div>ITEM(S)</div>
        </span>
        <i className="fa fa-shopping-cart text-black" />
      </button>
    ) : (
      <Tooltip
        position={"bottom right"}
        opener={() => (
          <button
            type="button"
            className="bs5 btn btn-secondary rounded-1 dropdown-toggle ms-2 header-cart-toggle"
            onClick={(e) => e.preventDefault()}
          >
            <span className="ms-1 header-cart-count d-md-inline-block text-black">
              <b>0</b>
              <div>ITEM(S)</div>
            </span>
            <i className="fa fa-shopping-cart text-black" />
          </button>
        )}
        content={() => (
          <>
            <div
              dangerouslySetInnerHTML={{
                __html: RoleAndPermission.getGuestErrorForBOMCart(),
              }}
            ></div>
          </>
        )}
      />
    );
  };

  const getUnitPrice = (unitPrice) => {
    return Helper.getFormatNumber(Number(unitPrice), window.mct, window.mcs, 5);
  }

  const getProductCartRedirectionLink = (v) => {
    if (v && CART_DATA_OBJECT_d && CART_DATA_OBJECT_d[v.ERPPartNumber]?.isProductAvailableFromMainAPI) {
      return `/${System.siteName()}/manufacturers/m/${v.manufacturerName?.toLowerCase()
        .replace(/\+/g, "and")
        .replace(/\&/g, "and")
        .replace(/\./g, "")
        .replace(/\//g, "-")
        .replace(/\,/g, "")
        .replace(/\s/g, "-")
        .replace(/\---/g, "-")}`
    }
    return '#';
  }
  return (
    <>
      <DOMAttachToSystem />
      {
        /**
         * Type  : Developer Note
         * Owner : Pankaj
         * Date  : 02/08/2022
         * Note  : Ln # 123 => PDG_VIEW_CART right is not valid for both non-logged in as
         *         well as for Auth_Account_Less user for that we're distinguishing based
         *         on guest rights & authentication (ex : PDG_VIEW_CART + Auth = AUTH_ACC_LESS
         *                                                No Auth & No PDG_VIEW_CART = Guest User).
         */
      }

      <div id='dvCartCountWidget' ref={cartDropDown} className="dropdown cartCountWidget">
        {_check_p('PDG_VIEW_CART').status === false ?
          getGuestDisplayTooltipButton() :
          <button type="button" className="bs5 btn btn-secondary rounded-1 dropdown-toggle ms-2 header-cart-toggle"
                  disabled={__check(['MINI_CART_API_CALL', 'CART_OPERATION_API_CALL', 'CHECK_CART_ITEM_EXIST', 'VIEW_CART_API_CALL']).status}
            data-toggle="dropdown" onClick={(e) => openCart(e)}>
            <>
              <span className="ms-1 header-cart-count d-md-inline-block text-black">
                {/*<b style={{ visibility: __check(['MINI_CART_API_CALL', 'CART_OPERATION_API_CALL']).status ? 'hidden' : 'visible' }}>*/}
                <b>
                  {authLoggedIn() === true &&
                    <>{CART_COUNT ? CART_COUNT : 0}</>
                  }
                  {!authLoggedIn() &&
                    <>0</>
                  }
                </b>
                <div>ITEM(S)</div>
              </span>
              <i className="fa fa-shopping-cart text-black" />
            </>
          </button>
        }
        {authLoggedIn() && _check_p("PD_VIEW_CART").status &&
          <div className="dropdown-menu dropdown-menu-right mini-cart mt-3" id="cart-popup">
            <div className="mini-cart-head">
              <h6>MY CART</h6>
            </div>

            {/* author: tusharKc
                ticket:- 7232
                removing loader from mini cart, in order to fix 7232
            */}
            {authLoggedIn() && CART_COUNT && CART_COUNT > 0 ?
              (
                <div className="mini-cart-btn">
                  <button className="bs5 btn btn-primary d-block most-viewd-item-btn m-auto"
                    onClick={() => {
                      window.location.href = Cart.getCartPageRouteURL();
                    }}
                  >
                    VIEW CART
                  </button>
                </div>
              ) : <></>
            }
            <>
              {/* 
                  Author: trilok sain
                  Ticket :- 9862
                  Reason : remove loader when only receive unavailable product in cart
              */}
              {authLoggedIn() && CART_DATA_d && CART_DATA_OBJECT_d && CART_PRODUCT_DATA && Object.entries(CART_DATA_OBJECT_d).length > 0 && CART_COUNT > 0 ? (
                <>
                  <div className="mini-cart-body">
                    <div className="bs5 row mini-cart-detail m-0">
                      <div className="col-8">
                        <strong>
                          ({CART_COUNT ? CART_COUNT : 0}) Item(s) in Your Cart
                        </strong>
                      </div>
                      <div className="col-4 text-end">
                        <ClearCart />
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table>
                        <tbody>
                          {isArray(CART_DATA_d) &&
                            CART_DATA_d.map((v) => (
                              <tr key={v.ItemNumber}>
                                <td className="pe-0 w80">
                                  <div className="product-img sect-1 text-center">
                                    <img src={v.assetURL !== undefined && v.assetURL !== null && v.assetURL.trim() !== "" ? v.assetURL : noImage} />
                                  </div>
                                </td>

                                <td>
                                  {CART_DATA_OBJECT_d[v.ERPPartNumber] !== undefined && CART_DATA_OBJECT_d[v.ERPPartNumber] !== null && (
                                    <div className={CART_DATA_OBJECT_d[v.ERPPartNumber]?.isProductAvailableFromMainAPI === false ? "product-name text-black" : "product-name"}>
                                      {CART_DATA_OBJECT_d[v.ERPPartNumber]?.isProductAvailableFromMainAPI &&
                                        <>
                                          <NavigateToPDP data={{
                                            ManufacturerName: v?.manufacturerName,
                                            ERPMFRPartNumber: v?.ERPMFRPartNumber,
                                            ItemNumber: v?.itemNumber,
                                          }} class="cursor-pointer text-wrap text-break bs5 d-inline-block">
                                            <strong>
                                              {v.ERPMFRPartNumber}
                                            </strong>
                                            <br />
                                          </NavigateToPDP>
                                        </>
                                      }
                                      {CART_DATA_OBJECT_d[v.ERPPartNumber]?.isProductAvailableFromMainAPI === false && (
                                        <strong>{v.ERPMFRPartNumber}</strong>
                                      )}
                                      {v.manufacturerName && (
                                        <a href={getProductCartRedirectionLink(v)} className="mt1 text-black"                                          >
                                          by{" "}
                                          {v.manufacturerName}
                                        </a>
                                      )}
                                    </div>
                                  )}
                                </td>

                                <td className="mini-cart-pricing pe-0">
                                  <div className="bs5 row">
                                    <div className="col-6">Unit Price:</div>
                                    <div className="col-6 text-end font_bold_currency">
                                      {" "}
                                      {getUnitPrice(v.unitPrice)}
                                    </div>
                                  </div>
                                  <div className="bs5 row">
                                    <div className="col-6">Quantity:</div>
                                    <div className="col-6 text-end font_bold_currency">
                                      {" "}
                                      {v.quantity}
                                    </div>
                                  </div>
                                </td>

                                <td className="ps-0 pe-1">
                                  <ClearSingleCartProductFromCart currentCartItem={v} >
                                    <div className="close-ic text-center">
                                      <img src={closeIc} />
                                    </div>
                                  </ClearSingleCartProductFromCart>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                    {/* <CartItemSubTotal /> */}
                    <div className="bs5 row m-0 mini-cart-item-total">
                      <div className="col-7 px-0">
                        <span><span className="cart-item-count"> </span>Items Subtotal:</span>
                      </div>
                      <div className="col-5 text-end font_bold_currency ps-1" >
                        <span className="font_bold_currency">{isNumber(subTotal) ? Helper.getFormatNumber(Number(subTotal)) : ""}</span>
                      </div>
                    </div>

                  </div>
                </>
              ) : (
                !(CART_DATA_OBJECT_d && CART_DATA_d &&
                  Object.entries(CART_DATA_OBJECT_d).length > 0 && Object.entries(CART_DATA_d).length > 0
                ) && _check_p("PD_VIEW_CART").status && CART_COUNT === 0 ? (
                  <>
                    <div className="mini-cart-body">
                      <div className="empty-cart">Your Cart is Empty</div>
                    </div>
                  </>
                ) :
                  <AxiosIndicatorRunTimeLoader />
              )}
            </>
          </div>
        }
      </div>

    </>
  );
};

export default HeaderTotalCartItems;
